import { API_ROOT_URL, IMAGE_SEARCH_API, getSidefilters } from '../helpers/api';
import {
  curatorActions,
  curatorSelector,
  selectedIsImageScanSearchFile,
} from '../redux/slicers/admin/curatorSlicer';
import {
  duplicateArrayRemove,
  extractIds,
  isInternalUser,
  objectToFormData,
  objectToSearchParams,
  removeSortParam,
  getLocalStorage
} from '../helpers/jsHelper';
import { orderBy, uniqueId } from 'lodash';
import {
  selectClickedSidefilterType,
  selectFilterValues,
  selectFilteroptions,
  setFilterValue,
  setLables,
  sidebarSelector,
} from '../redux/slicers/admin/sidebarSlicer';

import { LOADING_KEY } from '../helpers/reduxHelper';
import { LogCurator } from '../helpers/logEvents';
import { Recent_First_Value } from '../constants/filters';
import api from '../helpers/axiosHelper';
import { collectionItemsActions } from '../redux/slicers/collectionItemsSlicer';
import { dispatcher } from '../helpers/projectHelper';
import { fetchAllPages } from '../helpers/apiHelper';
import { getAppState } from '../redux/store';
import { successToast } from '../helpers/toastHelper';
import { paginatedProductSelector } from '../redux/slicers/admin/paginatedProductSlicer';
import { FILTER } from '../components/admin/curator/CuratorFilter/CuratorFilter';
import { CURRENT_USER } from '../constants/projectConstants';
import { MODEL_TYPES } from '../constants/constants';

export const createUpdateApiAction =
  ({ actions, loadingKey = LOADING_KEY.FAVOURITE, endpointUrl, progress }) =>
  ({ id, newSuccessMessage, ...rest }) =>
  (dispatch) => {
    const formData = objectToFormData(rest);

    const isFavouriteToggleAction =
      Object.keys(rest).length === 1 && typeof rest.is_favourite === 'boolean';
    if (isFavouriteToggleAction) {
      // we're toggling favourite
      dispatch(
        actions.setItemLoading({
          id,
          key: loadingKey,
          value: true,
        })
      );
    }

    const url = `${endpointUrl}${id}/`;

    const request = api()
      .root(API_ROOT_URL)
      .patch(url)
      .data(formData)
      .success((d) => {
        const data = d?.id ? d : d?.data;
        if (data) {
          dispatch(actions.update(data));
          dispatch(collectionItemsActions.updateItemInCollection({ data }));
        }

        if (isFavouriteToggleAction) {
          if (data.is_favourite) {
            successToast('Added to favourite');
          } else {
            successToast('Removed from favourite');
          }
        }
      });

    if (newSuccessMessage) {
      successToast(newSuccessMessage);
    }

    if (progress) {
      request.onUploadProgress((event) => {
        // loaded: 529963
        // total: 529963
        // type: "progress"

        if (event.type === 'progress') {
          dispatch(
            actions.setProgress({
              id: id,
              total: event.total,
              loaded: event.loaded,
            })
          );
        }
      });
    }

    request.error((e) => {
      console.error(e);
      // errorToast(e.message);
    });

    request.finally(() => {
      if (isFavouriteToggleAction) {
        dispatch(
          actions.setItemLoading({
            id,
            key: loadingKey,
            value: false,
          })
        );
      }
    });

    return request.send();
  };

export const createDeleteApiAction =
  ({ actions, endpointUrl, successMessage, optimistic = true }) =>
  ({ id, onSuccess, newSuccessMessage, query }) =>
  (dispatch) => {
    const _successMessage = newSuccessMessage || successMessage;

    if (optimistic) {
      dispatch(
        actions.deleteStart({
          itemId: id,
        })
      );
      _successMessage && successToast(_successMessage);
    }

    return api()
      .root(API_ROOT_URL)
      .delete(`${endpointUrl}${id}/?${query || ''}`)
      .requestConfig({
        messages: {
          403: 'You cannot delete other members file',
        },
      })
      .success((res) => {
        dispatch(
          actions.deleteSuccess({
            itemId: id,
          })
        );

        if (!optimistic) {
          _successMessage && successToast(_successMessage);
        }

        onSuccess?.();
      })
      .error((e) => {
        // errorToast('Some error occured');
        // TODO: work on this -> API never calls error if it's a network error or some other specific error
        dispatch(
          actions.deleteFailed({
            itemId: id,
            error: e,
          })
        );
      })
      .send();
  };

export const parseSidefilterParams = ({ searchParams, type = '', page = 1, labelId = null }) => {
  if (!searchParams) return '';
  let _params = new URLSearchParams(searchParams);
  const _paramsObj = {};
  if (type === 'filterOptions' && labelId) {
    _paramsObj['label_id'] = labelId.toString();
  }

  if (_params) {
    _params = _params
      .toString()
      .split('&')
      .filter(
        (a) =>
          ![
            'page',
            'sort',
            'is_configurator',
            'filterOrder',
            'is_mattress_builder_prop_removed',
          ].includes(a.toLowerCase().split('=')?.[0])
      )
      .filter((a) => !a.includes('fp_'));

    _params.forEach((a) => {
      let split = a.split('=');
      let key = split[0];
      let value = split[1];
      if (key === 'collections') {
        key = 'collection';
      } else if (key.includes('fl_') && !['filterLabels', 'filterOptions'].includes(type)) {
        if (value && _paramsObj['filter_option']) {
          _paramsObj['filter_option'] += `,${decodeURIComponent(value)}`;
        } else {
          _paramsObj['filter_option'] = decodeURIComponent(value);
        }
      }

      if (!key.includes('fl_')) {
        if (type === 'collections' && !['collection', 'label_id'].includes(key)) {
          _paramsObj[key] = value;
        } else if (type === 'brands' && !['brands', 'label_id'].includes(key)) {
          _paramsObj[key] = value;
        } else if (type === 'props' && !['props', 'label_id'].includes(key)) {
          _paramsObj[key] = value;
        } else if (type === 'filterLabels' && !['filter_option', 'label_id'].includes(key)) {
          _paramsObj[key] = value;
        } else if (type === 'filterOptions' && !['filter_option'].includes(key)) {
          _paramsObj[key] = value;
        }
      }
    });
  }

  let p = '';

  switch (type) {
    case 'collections':
      p = Object.entries(_paramsObj)
        .map(([key, value]) => {
          if (!key || !value) return false;
          return `${key}=${value ? value.replace(/\s/g, '') : ''}`;
        })
        .filter(Boolean)
        .join('&');
      break;
    case 'brands':
      p = Object.entries(_paramsObj)
        .map(([key, value]) => {
          if (!key || !value) return false;
          return `${key}=${value ? value.replace(/\s/g, '') : ''}`;
        })
        .filter(Boolean)
        .join('&');
      break;
    case 'filterLabels':
      p = Object.entries(_paramsObj)
        .map(([key, value]) => {
          if (!key || !value) return false;
          return `${key}=${value ? value.replace(/\s/g, '') : ''}`;
        })
        .filter(Boolean)
        .join('&');
      break;
    case 'filterOptions':
      p = Object.entries(_paramsObj)
        .map(([key, value]) => {
          if (!key || !value) return false;
          return `${key}=${value ? value.replace(/\s/g, '') : ''}`;
        })
        .filter(Boolean)
        .join('&');
      break;
    default:
  }

  // replacing "search" to "item_search" -> as for the filter we uses item_search key that being searched on the page search filter
  p = p?.replace('search=', 'item_search=');

  return `${p}&page=${page}`;
};

const getFilterDataLabelAndOptionsViaLabelId = ({ labelId = '', labelName = '' }) => {
  if (!labelId || !labelName)
    return { results: [], current_page_number: 1, count: 0, total_pages: 1 };

  const filterOptions = selectFilteroptions(getAppState());

  const data = filterOptions?.otherDetails?.[`${labelName}_${labelId}`] || {};
  return {
    results: filterOptions?.filteroptions.filter((a) => +a.filter_label === +labelId) || [],
    current_page_number: +data?.page,
    count: +data?.total,
    total_pages: +data?.total_pages,
  };
};

const getFilterDataAndOptionsViaKey = (key = '') => {
  if (!key) return { data: [], page: 1, total: 0, total_pages: 1 };

  const filterOptions = selectFilteroptions(getAppState());

  return {
    data: filterOptions?.[key] || [],
    ...filterOptions?.otherDetails?.[key],
  };
};

const generateFilterData = (data = {}) => {
  const { value } = data;
  const { results, current_page_number, count, total_pages } = value || {};
  return {
    data: results || [],
    page: +current_page_number || 1,
    total: count || 0,
    total_pages: total_pages || 1,
  };
};

// Function to generate the data structure based on the label
const generateSidefilterData = ({ label, results }) => {
  const dataStructureKeys = ['collections', 'brands', 'props'];
  const dataStructure = {};

  // Iterate through the keys and populate the data structure
  dataStructureKeys.forEach((key, index) => {
    // Check if a label is provided and matches the current key
    if (label && `${label}s` === key) {
      // If true, generate data structure using the key
      dataStructure[key] = getFilterDataAndOptionsViaKey(key);
    } else {
      // If false, generate data structure using the _sidefilter array at the current index
      dataStructure[key] = generateFilterData(results[index]);
    }
  });

  return dataStructure;
};

export const getFiltersPageNoByType = (type = null) => {
  if (!type) return 1;
  const params = new URLSearchParams(window.location.search);
  const page = params.get(`fp_${type.replaceAll(' ', '__')}`) || 1;
  return Number(page);
};

export const getOptimizeSidefilters = async ({ searchParams, modelType }) => {
  const clickedFilter = selectClickedSidefilterType(getAppState());

  const _collections =
    clickedFilter?.type === 'collection'
      ? []
      : fetchAllPages(
          (page) => {
            let params = parseSidefilterParams({ searchParams, type: 'collections', page });
            if (modelType === MODEL_TYPES.THREEDMODELS) {
              const orgId = getLocalStorage(CURRENT_USER, true)?.organization;
              params += params ? `&brands=${orgId}` : `brands=${orgId}`;
            }
            return getSidefilters({
              params,
              type: 'collections',
              modelType,
            });
          },
          getFiltersPageNoByType('collections')
        );
  const _brands =
    clickedFilter?.type === 'brand'
      ? []
      : fetchAllPages(
          (page) =>
            getSidefilters({
              params: parseSidefilterParams({ searchParams, type: 'brands', page }),
              type: 'brands',
              modelType,
            }),
          getFiltersPageNoByType('brands')
        );
  const _prop =
    clickedFilter?.type === 'prop'
      ? []
      : fetchAllPages(
          (page) =>
            getSidefilters({
              params: parseSidefilterParams({ searchParams, type: 'props', page }),
              type: 'props',
              modelType,
            }),
          getFiltersPageNoByType('props')
        );
  const _filterlabels = await fetchAllPages(
    async (page) =>
      await getSidefilters({
        params: parseSidefilterParams({ searchParams, type: 'filterLabels', page }),
        type: 'filterLabels',
        modelType,
      })
  );

  let _filteroptions = [];
  if (_filterlabels?.results?.length > 0) {
    const labels = _filterlabels?.results?.map((a) => ({
      id: a.id,
      name: a.label_name,
    }));
    _filteroptions = await Promise.all(
      labels
        .filter((a) => a.id !== clickedFilter?.id)
        .map(
          async ({ id, name }) =>
            await fetchAllPages(
              async (page) =>
                await getSidefilters({
                  params: parseSidefilterParams({
                    searchParams,
                    type: 'filterOptions',
                    page,
                    labelId: id,
                  }),
                  type: 'filterOptions',
                  modelType,
                }),
              getFiltersPageNoByType(`${name}_${id}`)
            )
        )
    );

    if (clickedFilter && clickedFilter?.id) {
      _filteroptions = [
        ..._filteroptions,
        getFilterDataLabelAndOptionsViaLabelId({
          labelId: clickedFilter?.id,
          labelName: labels.find((a) => +a.id === +clickedFilter?.id)?.name,
        }),
      ];
    }
  }

  const promisesMap = {
    collection: [_brands, _prop],
    brand: [_collections, _prop],
    prop: [_collections, _brands],
  };

  // Get the promises list based on the clickedFilterLabel or default to all three
  const promisesList = ['collections', 'brands', 'props'].includes(clickedFilter?.type)
    ? promisesMap[clickedFilter?.type]
    : [_collections, _brands, _prop];

  const _sidefilter = await Promise.allSettled(promisesList);
  // Generate the side filter data based on the clicked sidefilter
  const _sidefilterData = generateSidefilterData({
    label: clickedFilter?.type,
    results: _sidefilter,
  });

  return {
    _sidefilter: _sidefilterData,
    _filterlabels,
    _filteroptions,
  };
};

const optimizeSearchParams = (searchParams) => {
  const splitParams = searchParams.toString().split('&');
  const filterOptionsParams = splitParams.filter((param) => param.includes('fl_'));

  let isUnassignedSelected = '';

  // Decode and process filter options values
  const filterOptionsValues = filterOptionsParams.map((param) => {
    const { 0: key, 1: value } = param.split('=');
    if (value.includes('ua')) {
      isUnassignedSelected = `filterlabel=${key.split('_')?.[1]}`;
    }
    const decodeArr = decodeURIComponent(value);
    return decodeArr.includes(',') ? decodeArr.split(',') : decodeArr;
  });

  const flattenedFilterOptionsValues = duplicateArrayRemove(filterOptionsValues.flat());

  const nonFilterOptionsParams = splitParams.filter((param) => !param.includes('fl_'));

  // Find the index of the first filter options parameter
  const filterOptionsParamsIndex = splitParams.findIndex((param) => param.includes('fl_'));

  // Insert the flattened filter options values into non-filter options parameters at the correct index
  if (filterOptionsParamsIndex !== -1 && flattenedFilterOptionsValues.length > 0) {
    let flValue = `filteroptions=${flattenedFilterOptionsValues.join(',')}`;
    if (isUnassignedSelected) {
      flValue += `&${isUnassignedSelected}`;
    }
    nonFilterOptionsParams.splice(filterOptionsParamsIndex, 0, flValue);
  }

  return nonFilterOptionsParams.join('&');
};

export const createGetListAction =
  ({
    endpoint,
    formatEndpoint = null,
    actions,
    apiRootUrl,
    defaultSort = Recent_First_Value,
    setGlobalSidebarFilters,
    skipBrandFilter,
    dataFormattter,
    parseSidefilter,
    useOptimizedAPI = false,
    modelType = null,
  }) =>
  ({
    searchConfig,
    page,
    perPage,
    skipBrandFilter: requestSkipBrandFilter,
    sort = defaultSort,
    // tags=[],
    arrayParams = {},
    ...rest
  }) =>
  (dispatch) => {
    const obj = {
      ...rest,
      page,
      per_page: typeof rest.per_page === 'number' ? rest.per_page : perPage,
      sort,
    };

    if (obj.sort === null) {
      delete obj.sort;
    }

    const currentURL = window.location.href;
    // Parse the URL to get query parameters
    const url = new URL(currentURL);
    const roomType = +url.searchParams.get('roomType');
    if (~roomType && roomType && !rest?.room_type) {
      obj.room_type = roomType;
    }
    if (rest.search && removeSortParam()) {
      // as per Aakash request when we search -> we remove sort parameter as items are already sorted by relevance
      delete obj.sort;
    }

    const extraParams = obj?.extra_params;
    delete obj?.extra_params;
    //   Fix for filter mismatch issue in Curator > Product tab.
    //   In some edge cases, UI filters (Brand and My Module) were not resetting properly, 
    //   causing incorrect values to be sent in API params. This led to data mismatch 
    //   between the selected filters and the results.
    //   This code ensures filters are correctly synced with the UI before making API calls.
    //   https://app.clickup.com/t/3326989/DEV-38061
    // line number (530 to 549)
    const { filterValue } = paginatedProductSelector(getAppState());
    const filterOption = curatorSelector(getAppState())?.filterOpen === "product";
    if(filterOption && filterValue?.length){
      const orgId = JSON.parse(localStorage.getItem(CURRENT_USER))?.organization;
      if(filterValue.filter(item => item?.startsWith('brand_'))?.length){
        const removeDuplicateIds = (inputString) => {
          const unique = Array.from(new Set(inputString.split(',').map(item => item.trim())));
          return unique.join(',');
        }
        if(filterValue?.find((info)=> info === FILTER.MY_3D_MODELS)){
          obj.brands = removeDuplicateIds(`${orgId},${extractIds(filterValue, 'brand_')}`)
        }else{
          obj.brands = removeDuplicateIds(`${extractIds(filterValue, 'brand_')}`)
        }
      }else if(obj.brands && !filterValue?.find((info)=> info === FILTER.MY_3D_MODELS)){
        delete obj.brands
      }else if(filterValue?.find((info)=> info === FILTER.MY_3D_MODELS)){
        obj.brands = orgId
      }    
    }
    let searchParams = objectToSearchParams(obj);
    
    if (Object.keys(arrayParams).length) {
      Object.keys(arrayParams).map((item) => {
        const query = arrayParams[item].map((a) => `tags=${a}`).join('&');
        searchParams += '&' + query;
      });
    }

    if (extraParams) {
      const otherParams = objectToSearchParams(extraParams);
      searchParams = `${searchParams}&${otherParams}`;
    }

    // if(tags.length){
    //   const query = tags.map((a) => `tags=${a}`).join('&');
    //   searchParams += '&' + query
    // }
    let sidefilter = {};

    const { filtersData, doFilterUpdateValue } = sidebarSelector(getAppState());
    const updateFilterData = !filtersData || doFilterUpdateValue;
    if (useOptimizedAPI && modelType) {
      searchParams = optimizeSearchParams(searchParams);
    }

    const API_URL = formatEndpoint ? formatEndpoint?.(`${endpoint}?${searchParams}`) : `${endpoint}?${searchParams}`;

    const requestId = uniqueId();

    const start = searchConfig ? actions.searchStart : actions.fetchListStart;
    const success = searchConfig ? actions.searchSuccess : actions.fetchListSuccess;
    const failed = searchConfig ? actions.searchFailed : actions.fetchListFailed;
    const setLoading = searchConfig ? actions.setLoading : actions.setLoading;

    dispatch(start({ requestId }));

    if (useOptimizedAPI && modelType && updateFilterData) {
      getOptimizeSidefilters({
        searchParams,
        modelType,
      }).then(({ _sidefilter, _filterlabels, _filteroptions }) => {
        const labelOptionObject = {};
        _filterlabels?.results.forEach((label) => {
          const id = label?.id;
          const label_name = label?.label_name;
          const isProductPageFilter = label?.is_product_page_filter; // we get this filter from the product / texture api only
          const option = _filteroptions?.filter(
            (item) => item.results?.[0]?.filter_label === id
          )?.[0];

          labelOptionObject[`${label_name}_${id}`] = {
            page:
              getFiltersPageNoByType(`${label_name}_${id}`) || +option?.current_page_number || 1,
            total: option?.count || 0,
            total_pages: option?.total_pages || 1,
            ...(isProductPageFilter
              ? {
                  isProductPageFilter: true,
                }
              : {}),
          };
        });

        sidefilter = {
          filterlabels: _filterlabels?.results || [],
          collections: _sidefilter?.collections?.data || [],
          brands: _sidefilter?.brands?.data || [],
          props: _sidefilter?.props?.data || [],
          filteroptions: _filteroptions.map((a) => a.results).flat() || [],
          order: ['collections', 'brands', 'filterlabels', 'filteroptions', 'props'],
          otherDetails: {
            collections: {
              ..._sidefilter?.collections,
              page: getFiltersPageNoByType('collections'),
            },
            brands: {
              ..._sidefilter?.brands,
              page: getFiltersPageNoByType('brands'),
            },
            props: {
              ..._sidefilter?.props,
              page: getFiltersPageNoByType('props'),
            },
            ...labelOptionObject,
          },
        };

        if (parseSidefilter) {
          sidefilter = parseSidefilter(sidefilter);
        }
        if (skipBrandFilter || requestSkipBrandFilter) {
          sidefilter.brands = [];
        }
        if (MODEL_TYPES.MATERIAL === modelType && isInternalUser() && !sidefilter.brands?.length) {
          sidefilter.brands = _sidefilter?.brands?.data;
        }
        if (!searchConfig) {
          // TODO: sort here
          const sortedFilters = sortFilters(sidefilter);
          dispatch(actions.setFilter(sortedFilters));
        }

        if (setGlobalSidebarFilters && page === 1) {
          const filterValues = selectFilterValues(getAppState());
          // some of the filters might not be available after fetching data -> so we need to remove them from selected filters
          const newFilterValues = filterNotAvailableFilters(filterValues, sidefilter);

          if (filterValues.length !== newFilterValues.length) {
            dispatch(setFilterValue(newFilterValues));
          }

          dispatch(setLables({ sidefilter }));
        }
      });
    }

    return api()
      .root(apiRootUrl || API_ROOT_URL)
      .get(API_URL)
      .success(async (data) => {
        data.results = dataFormattter ? data.results.map(dataFormattter) : data.results;

        dispatch(
          success({
            page: page,
            data,
            requestId,
          })
        );

        if (!(useOptimizedAPI && modelType)) {
          sidefilter = { ...data?.sidefilter };

          if (parseSidefilter) {
            sidefilter = parseSidefilter(sidefilter);
          }
          if (skipBrandFilter || requestSkipBrandFilter) {
            sidefilter.brands = [];
          }

          if (!searchConfig) {
            // TODO: sort here
            const sortedFilters = sortFilters(sidefilter);
            dispatch(actions.setFilter(sortedFilters));
          }

          if (setGlobalSidebarFilters && page === 1) {
            const filterValues = selectFilterValues(getAppState());
            // some of the filters might not be available after fetching data -> so we need to remove them from selected filters
            const newFilterValues = filterNotAvailableFilters(filterValues, sidefilter);

            if (filterValues.length !== newFilterValues.length) {
              dispatch(setFilterValue(newFilterValues));
            }

            dispatch(setLables({ sidefilter }));
          }
        }
      })
      .anyError((error) => {
        // TODO: add logger
        console.error(error);
        dispatch(failed({ error, requestId }));
      })
      .send();
  };

export const createPostApiAction =
  ({
    endpoint = IMAGE_SEARCH_API,
    actions,
    apiRootUrl,
    defaultSort = Recent_First_Value,
    setGlobalSidebarFilters,
    skipBrandFilter,
    dataFormattter,
    parseSidefilter,
    skipFilterUpdate = false
  }) =>
  ({
    searchConfig,
    page,
    perPage,
    skipBrandFilter: requestSkipBrandFilter,
    sort = defaultSort,
    // tags=[],
    arrayParams = {},
    ...rest
  }) =>
  (dispatch) => {
    const obj = {
      ...rest,
      page,
      // per_page: typeof rest.per_page === 'number' ? rest.per_page : perPage,
      // sort,
    };

    // if (obj.sort === null) {
    //   delete obj.sort;
    // }

    // if (rest.search) { // as per Aakash request when we search -> we remove sort parameter as items are already sorted by relevance
    //   delete obj.sort;
    // }

    let searchParams = objectToSearchParams(obj);
    if (Object.keys(arrayParams).length) {
      Object.keys(arrayParams).map((item) => {
        const query = arrayParams[item].map((a) => `tags=${a}`).join('&');
        searchParams += '&' + query;
      });
    }

    const file = selectedIsImageScanSearchFile(getAppState());
    const image = file?.croppedImage; // || file?.url?.split('base64,')?.[1];

    if (!image) return;

    const formData = new FormData();

    if (file?.embedding) {
      formData.append('embedding', JSON.stringify(file?.embedding));
    } else {
      formData.append('image', image);
    }

    // if(tags.length){
    //   const query = tags.map((a) => `tags=${a}`).join('&');
    //   searchParams += '&' + query
    // }
    const API_URL = `${endpoint}?${searchParams}`;

    const requestId = uniqueId();

    const start = searchConfig ? actions.searchStart : actions.fetchListStart;
    const success = searchConfig ? actions.searchSuccess : actions.fetchListSuccess;
    const failed = searchConfig ? actions.searchFailed : actions.fetchListFailed;
    const setLoading = searchConfig ? actions.setLoading : actions.setLoading;

    dispatch(start({ requestId }));

    return api()
      .root(apiRootUrl || API_ROOT_URL)
      .post(API_URL)
      .data(formData)
      .success((data) => {
        dispatcher(curatorActions.setImageScanSearchFile({ ...file, embedding: data?.embedding }));
        data.results = dataFormattter ? data.results.map(dataFormattter) : data.results;

        dispatch(
          success({
            page: page,
            data,
            requestId,
          })
        );

        if(!skipFilterUpdate) {

        let sidefilter = { ...data?.sidefilter };
        if (parseSidefilter) {
          sidefilter = parseSidefilter(sidefilter);
        }
        if (skipBrandFilter || requestSkipBrandFilter) {
          sidefilter.brands = [];
        }

        if (!searchConfig) {
          // TODO: sort here
          const sortedFilters = sortFilters(sidefilter);
          dispatch(actions.setFilter(sortedFilters));
        }

        if (setGlobalSidebarFilters && page === 1) {
          const filterValues = selectFilterValues(getAppState());
          // some of the filters might not be available after fetching data -> so we need to remove them from selected filters
          const newFilterValues = filterNotAvailableFilters(filterValues, sidefilter);

          if (filterValues.length !== newFilterValues.length) {
            dispatch(setFilterValue(newFilterValues));
          }

          dispatch(setLables({ sidefilter }));
        }
      }
      })
      .badRequest400(() => {})
      .anyError((error) => {
        // TODO: add logger
        console.error(error);
        dispatch(failed({ error, requestId }));
      })
      .send();
  };

export const sortFilters = (sidefilter) => {
  if (!sidefilter) return sidefilter;
  const brands = sidefilter.brands || [];
  const collections = sidefilter.collections || [];
  const filteroptions = sidefilter.filteroptions || [];

  return {
    ...sidefilter,
    brands: orderBy(brands, (a) => a.name?.toLowerCase(), ['asc']),
    collections: orderBy(collections, (a) => a.name?.toLowerCase(), ['asc']),
    filteroptions: orderBy(filteroptions, (a) => a.name?.toLowerCase(), ['asc']),
  };
};

export const filterNotAvailableFilters = (values, sidefilter) => {
  const newFilterValues = [];

  values.forEach((value) => {
    if (value.startsWith('option_')) {
      const [, labelId, optionId] = value.split('_');
      const option = sidefilter?.filteroptions?.find((option) => `${option.id}` === `${optionId}`);
      if (option) {
        newFilterValues.push(value);
      }
      return;
    }

    if (value.startsWith('brand_')) {
      const [, brandId] = value.split('_');
      const brand = sidefilter?.brands?.find((brand) => `${brand.id}` === `${brandId}`);
      if (brand) {
        newFilterValues.push(value);
      }
      return;
    }

    if (value.startsWith('collection_')) {
      const [, collectionId] = value.split('_');
      const collection = sidefilter?.collections?.find(
        (collection) => `${collection.id}` === `${collectionId}`
      );
      if (collection) {
        newFilterValues.push(value);
      }
      return;
    }

    if (value.startsWith('prop_')) {
      const [, propId] = value.split('_');
      const prop = sidefilter?.props?.find((prop) => `${prop.id}` === `${propId}`);
      if (prop) {
        newFilterValues.push(value);
      }
      return;
    }

    newFilterValues.push(value);
  });

  return newFilterValues;
};
